/**
 * Hero Banner Appearance values – must match Contentful "Appearance" field allowed values exactly.
 * Used for routing and theme variant selection. Do not change unless Contentful model is updated.
 *
 * @see Contentful: Hero Banner content type → Appearance field → "Accept only specified values"
 */
export const HERO_BANNER_APPEARANCE = {
  CF_01: 'Hero Banner Block (CF-01)',
  CF_04: 'Hero Banner Block (CF-04)',
  CF_06: 'Hero Banner Block (CF-06)',
  CALLOUT_SPLIT_CF_023: 'Callout Block - Split (CF-023)',
  CALLOUT_OVERLAY_CF_024: 'Callout Block - Overlay (CF-024)',
};
